// components/cookie-banner/cookie-banner.component.ts
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CookieService, CookiePreferences } from '../../core/services/cookie.service';
import { Configuracoes } from 'src/app/core/entities/configuracoes';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent implements OnInit{
  @Output() closed = new EventEmitter<void>();
  
  showDetails = false;
  lgpd = ''
  preferences: CookiePreferences = {
    necessary: true,
    analytics: false,
    marketing: false,
    preferences: false
  };

  constructor(private cookieService: CookieService) {
    // Se já tem preferências salvas, não mostrar o banner
    if (this.cookieService.hasConsent()) {
      this.hide();
    }
    this.lgpd = Configuracoes.SITE.lgpd;
  }
  
  ngOnInit(): void {
    this.lgpd = Configuracoes.SITE.lgpd;
  }

  acceptAll(): void {
    this.preferences = {
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    };
    this.savePreferences();
  }

  acceptNecessary(): void {
    this.preferences = {
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    };
    this.savePreferences();
  }

  savePreferences(): void {
    this.cookieService.savePreferences(this.preferences);
    this.hide();
  }

  toggleDetails(): void {
    this.showDetails = !this.showDetails;
  }

  private hide(): void {
    this.closed.emit();
  }

  get isVisible(): boolean {
    return !this.cookieService.hasConsent();
  }
}